import * as React from "react";

import BundleDiscountsCustomPropModifier from "@editor/components/editor/customProp/BundleDiscountsCustomPropModifier";
import BundleProductsCustomPropModifier from "@editor/components/editor/customProp/BundleProductsCustomPropModifier";
import { selectDraftComponent } from "@editor/reducers/core-reducer";
import { useEditorSelector } from "@editor/store";

import Button from "@replo/design-system/components/button/Button";
import Popover from "@replo/design-system/components/popover/Popover";

export const BundleBuilderConfigMenu: React.FC = () => {
  const draftComponent = useEditorSelector(selectDraftComponent);
  if (!draftComponent) {
    return null;
  }
  return (
    <div className="relative flex flex-col gap-4">
      <BundleProductsCustomPropModifier component={draftComponent} />
      <Popover.Root shouldIgnoreOutsideInteractions={false}>
        <Popover.Trigger asChild>
          <Button variant="secondary">Configure Discounts</Button>
        </Popover.Trigger>
        <Popover.Content
          stayInPosition
          shouldPreventDefaultOnInteractOutside={false}
          side="left"
          align="center"
          hideCloseButton
          className="w-[300px]"
        >
          <BundleDiscountsCustomPropModifier component={draftComponent} />
        </Popover.Content>
      </Popover.Root>
    </div>
  );
};
